import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { CreateCollectionWizardComponent } from './create-collection-wizard.component';

@Component({
  selector: 'app-create-collection-wizard-action',
  template: `
    @if (canShow) {
      <button
        mat-menu-item
        (click)="onStart()"
        [disabled]="selectedProducts.length === 0"
        >
        <mat-icon>send</mat-icon>
        <span>Create Collection</span>
      </button>
    }
    `,
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class CreateCollectionWizardActionComponent implements OnInit {
  @Input() selectedProducts: IProduct[] = [];
  @Input() organizationId!: string;
  @Input() batchId!: string;
  @Output() visibilityDeclared = new EventEmitter<boolean>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  hasPermission(): boolean {
    return (
      this.authService.hasPermission(Permission.OutputsCollectionsFull) &&
      this.authService.hasPermission(Permission.ProductsLabelData)
    );
  }

  get canShow(): boolean {
    return this.hasPermission();
  }

  ngOnInit(): void {
    Promise.resolve().then(() => this.visibilityDeclared.emit(this.canShow));
  }

  onStart(): void {
    const productIds = this.selectedProducts.map((p) => p.id!).filter((id) => !!id);
    if (productIds.length === 0) return;

    this.dialog.open(CreateCollectionWizardComponent, {
      width: '900px',
      maxHeight: '90vh',
      data: {
        organizationId: this.organizationId,
        batchId: this.batchId,
        productIds,
        products: this.selectedProducts,
      },
    });
  }
}
